const events = require('events-mixin');

const _ = require('./i18n');

class Follow {
  constructor(element) {
    this.element = element;
    this.bindEvents();
  }

  bindEvents() {
    this.events = events(this.element, this);
    this.events.bind({
      'click .follow-activate': 'follow',
    });
  }

  follow() {
    const text = _('Following');
    this.element.innerHTML = `
      <span class="button button-flat" disabled>${text}</span>
    `;

    this.sendMetrics();
  }

  sendMetrics() {
    const { ga } = window;

    ga('send', {
      hitType: 'event',
      eventCategory: 'follow',
      eventAction: 'follow',
      eventLabel: this.element.getAttribute('data-title'),
    });
  }
}

module.exports = Follow;
